import React from 'react';
import { Box, Typography } from '@mui/material';
import { guaranteesClientPageStyles } from '~/modules/guarantees/form/client/styles.ts';
import type { TGuaranteesTimelineEvent } from '~/store/guarantees/types.ts';
import { STATUS_FLOW_TOOLTIP_SEPARATOR } from './constants.ts';
import { getFormattedDateTime, localizeStatusEnumText } from './utils.ts';

interface IStatusFlowTooltipContentProps {
  event?: TGuaranteesTimelineEvent;
}

const StatusFlowTooltipContent: React.FC<IStatusFlowTooltipContentProps> = ({ event }) => {
  const performer = [event?.changedByName, event?.changedByEmail]
    .filter(Boolean)
    .join(STATUS_FLOW_TOOLTIP_SEPARATOR);

  return (
    <Box sx={guaranteesClientPageStyles.statusFlowTooltipContent}>
      <Typography sx={guaranteesClientPageStyles.statusFlowTooltipLine}>
        {getFormattedDateTime(event?.changedAt)}
      </Typography>
      {!!performer && (
        <Typography sx={guaranteesClientPageStyles.statusFlowTooltipLine}>{performer}</Typography>
      )}
      {!!event?.description && (
        <Typography sx={guaranteesClientPageStyles.statusFlowTooltipDescription}>
          {localizeStatusEnumText(event.description)}
        </Typography>
      )}
    </Box>
  );
};

export default StatusFlowTooltipContent;
